import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-employee-management',
  templateUrl: './employee-management.component.html',
  styleUrls: ['./employee-management.component.css']
})
export class EmployeeManagementComponent implements OnInit {

  constructor(private employeeService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[];
  department:any=[];

  baseUrl=this.employeeService.ReturnBase();
  getUrl=this.baseUrl+'viewEmployees';
  deptUrl=this.baseUrl+'viewDepartments/department_dropdown';
  empUrl=this.baseUrl+'viewEmployees/employee_list/department?department=';
  searchEmployeeUrl=this.baseUrl+'viewEmployees?employee_name=';
  /*
  getUrl='http://192.241.151.66:5000/viewEmployees';
  deptUrl='http://192.241.151.66:5000/viewDepartments/department_dropdown';
  empUrl='http://192.241.151.66:5000/viewEmployees/employee_list/department?department=';
  searchEmployeeUrl='http://192.241.151.66:5000/viewEmployees?employee_name='
  */
  isShownEmployee=false
  count=0;
  search: string = '';
  selectedTeam = '';
  employee:any=[];
  searchFlag=0
  loaderShown=true;
  CardShown=false;

  //------routing to edit page--------------------
    
  EditEmployee(){
    this.router.navigateByUrl(('admin/edit-employee'));  
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
 
  //-------------function for search--------------------
Search(){
  console.log("click search",this.search);
  if(this.search!='')
  {
  this.isShownEmployee=true;
  this.employeeService.getData(this.searchEmployeeUrl+this.search+'&offset=0&limit=20').subscribe((res)=>{
  this.output=res.data
  })
  this.count=0
  this.searchFlag=1
}
else{
   //-------api get()calling-------------
   this.employeeService.getData(this.getUrl).subscribe((res)=>{
   this.output=res.data

  })
}
}
  //------function for routing-------------------------

  employeeDetails(){
  this.router.navigateByUrl(('admin/employee-details')); 
  document.body.scrollTop = document.documentElement.scrollTop = 0; 
}

//--------function which give name of selected item---------
getValue = (item : string) =>{
   
  this.employeeService.setEmployeeId(item)
  console.log("error=",item)

}

//function for going to next page
  clicks_next(){
   
    this.count=this.count+1;
    
    console.log("hai click on one",this.count)

    if(this.selectedTeam !='ALL' && this.search!='')
    {
      console.log("1")
      this.employeeService.getData(this.searchEmployeeUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
        this.output=res.data
      })
    }
    else if(this.selectedTeam !='ALL' && this.search==''){
      console.log("2")
      //-------api get()calling for deptmt wise details-------------
     this.employeeService.getData(this.empUrl+this.selectedTeam+'&offset='+this.count+'&limit=20').subscribe((res)=>{
     this.output=res.data
      })

    }
    else if(this.selectedTeam =='ALL' && this.search!='')
    {
      console.log("3")
      this.employeeService.getData(this.searchEmployeeUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
     })
     
    }
    else{
      console.log("4")
    //-------api get()calling for next page-------------
    this.employeeService.getData(this.getUrl+'?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    })
  }
  }
  
  //function for going to previous page
  clicks_previous(){
 
    this.count=this.count-1;
    if(this.count<0)
    {
      this.count=0
    }
    if(this.selectedTeam !='ALL' && this.search!='')
    {
      this.employeeService.getData(this.searchEmployeeUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
        this.output=res.data
       })
    }
    else if(this.selectedTeam !='ALL' && this.search==''){
      //-------api get()calling for deptmt wise details-------------
     this.employeeService.getData(this.empUrl+this.selectedTeam+'&offset='+this.count+'&limit=20').subscribe((res)=>{
     this.output=res.data
      })

    }
    else if(this.selectedTeam =='ALL' && this.search!='')
    {
      this.employeeService.getData(this.searchEmployeeUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
     })
     
    }
  
    else{
    //-------api get()calling for previous page-------------
    console.log("Count=",this.count)
    this.employeeService.getData(this.getUrl+'?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    })
  }
  }

  //---------for select a particular department----------
  
	onSelected(value:string): void {
		this.selectedTeam = value;
    console.log("selectsss=",this.selectedTeam);

    if(this.selectedTeam !='ALL')
    {
      this.count=0;
     //-------api get()calling for deptmt wise details-------------
     this.employeeService.getData(this.empUrl+this.selectedTeam+'&offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
      console.log("Employee details =",this.output)

    })
  }
  else{
     
    this.employeeService.getData(this.getUrl).subscribe((res)=>{
    this.output=res.data
    
    })
    

  }
	}
  
  ngOnInit(): void {
    this.selectedTeam='ALL'
    //-------api get()calling-------------
    this.employeeService.getData(this.getUrl).subscribe((res)=>{
      this.output=res.data
      console.log("Employee details =",this.output)
      this.loaderShown=false;
      this.CardShown=true;

    })

    //-------api for get department name---------

    this.employeeService.getData(this.deptUrl).subscribe((res)=>{
      this.department=res.data
      console.log("Department details =",this.department)

    })


  }

}
function clicks() {
  throw new Error('Function not implemented.');
}

